var React = require('react');

function Italic (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M14.2495 5.24951L9.74951 18.7495","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M5.99951 18.7495H13.4995","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M10.4995 5.24951H17.9995","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Italic.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 24 24","fill":"none"};

module.exports = Italic;

Italic.default = Italic;
